import { render, staticRenderFns } from "./SoundOverview.vue?vue&type=template&id=05ccbcdd&"
import script from "./SoundOverview.vue?vue&type=script&lang=js&"
export * from "./SoundOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports